module.exports = __webpack_public_path__ + "static/media/Las-Vegas-Skyline-at-Sunset-1088x400.ea87414c.png";